webpackJsonp([108009296967943],{

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(8);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DISQUS_CONFIG = ['shortname', 'identifier', 'title', 'url', 'category_id', 'onNewComment', 'language'];
	var __disqusAdded = false;
	
	function copyProps(context, props) {
	    var onNewComment = props.onNewComment,
	        language = props.language,
	        rest = _objectWithoutProperties(props, ['onNewComment', 'language']);
	
	    for (var prop in rest) {
	        context.page[prop] = rest[prop];
	    }
	
	    // Setting the language - if none is provided, the default one is used
	    context.language = language;
	
	    if (onNewComment) {
	        context.callbacks = {
	            onNewComment: [onNewComment]
	        };
	    }
	}
	
	var DisqusThread = function (_React$Component) {
	    _inherits(DisqusThread, _React$Component);
	
	    function DisqusThread() {
	        _classCallCheck(this, DisqusThread);
	
	        return _possibleConstructorReturn(this, (DisqusThread.__proto__ || Object.getPrototypeOf(DisqusThread)).apply(this, arguments));
	    }
	
	    _createClass(DisqusThread, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadDisqus();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.loadDisqus();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextProps.identifier !== this.props.identifier;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var props = Object.keys(this.props).reduce(function (memo, key) {
	                return DISQUS_CONFIG.some(function (config) {
	                    return config === key;
	                }) ? memo : _extends({}, memo, _defineProperty({}, key, _this2.props[key]));
	            }, {});
	
	            return _react2.default.createElement(
	                'div',
	                props,
	                _react2.default.createElement('div', { id: 'disqus_thread' })
	            );
	        }
	    }, {
	        key: 'addDisqusScript',
	        value: function addDisqusScript() {
	            if (__disqusAdded) {
	                return;
	            }
	
	            var child = this.disqus = document.createElement('script');
	            var parent = document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0];
	
	            child.async = true;
	            child.type = 'text/javascript';
	            child.src = '//' + this.props.shortname + '.disqus.com/embed.js';
	
	            parent.appendChild(child);
	            __disqusAdded = true;
	        }
	    }, {
	        key: 'loadDisqus',
	        value: function loadDisqus() {
	            var _this3 = this;
	
	            var props = {};
	
	            // Extract Disqus props that were supplied to this component
	            DISQUS_CONFIG.forEach(function (prop) {
	                // prop "shortname" is only necessary for loading the script, not for the config itself
	                if (prop !== 'shortname' && !!_this3.props[prop]) {
	                    props[prop] = _this3.props[prop];
	                }
	            });
	
	            // If Disqus has already been added, reset it
	            if (typeof DISQUS !== 'undefined') {
	                DISQUS.reset({
	                    reload: true,
	                    config: function config() {
	                        copyProps(this, props);
	
	                        // Disqus needs hashbang URL, see https://help.disqus.com/customer/portal/articles/472107
	                        this.page.url = this.page.url.replace(/#/, '') + '#!newthread';
	                    }
	                });
	            } else {
	                // Otherwise add Disqus to the page
	                window.disqus_config = function () {
	                    copyProps(this, props);
	                };
	                this.addDisqusScript();
	            }
	        }
	    }]);
	
	    return DisqusThread;
	}(_react2.default.Component);
	
	DisqusThread.displayName = 'DisqusThread';
	
	DisqusThread.propTypes = {
	    id: _propTypes2.default.string,
	
	    /**
	     * `shortname` tells the Disqus service your forum's shortname,
	     * which is the unique identifier for your website as registered
	     * on Disqus. If undefined , the Disqus embed will not load.
	     */
	    shortname: _propTypes2.default.string.isRequired,
	
	    /**
	     * `identifier` tells the Disqus service how to identify the
	     * current page. When the Disqus embed is loaded, the identifier
	     * is used to look up the correct thread. If disqus_identifier
	     * is undefined, the page's URL will be used. The URL can be
	     * unreliable, such as when renaming an article slug or changing
	     * domains, so we recommend using your own unique way of
	     * identifying a thread.
	     */
	    identifier: _propTypes2.default.string,
	
	    /**
	     * `title` tells the Disqus service the title of the current page.
	     * This is used when creating the thread on Disqus for the first time.
	     * If undefined, Disqus will use the <title> attribute of the page.
	     * If that attribute could not be used, Disqus will use the URL of the page.
	     */
	    title: _propTypes2.default.string,
	
	    /**
	     * `url` tells the Disqus service the URL of the current page.
	     * If undefined, Disqus will take the window.location.href.
	     * This URL is used to look up or create a thread if disqus_identifier
	     * is undefined. In addition, this URL is always saved when a thread is
	     * being created so that Disqus knows what page a thread belongs to.
	     */
	    url: _propTypes2.default.string,
	
	    /**
	     * `category_id` tells the Disqus service the category to be used for
	     * the current page. This is used when creating the thread on Disqus
	     * for the first time.
	     */
	    category_id: _propTypes2.default.string,
	
	    /**
	     * `onNewComment` function accepts one parameter `comment` which is a
	     * JavaScript object with comment `id` and `text`. This allows you to track
	     * user comments and replies and run a script after a comment is posted.
	     */
	    onNewComment: _propTypes2.default.func,
	
	    /**
	     * `language` tells the Disqus service which language should be used.
	     * Please refer to https://www.transifex.com/disqus/disqus/ on which languages can be used
	     * If undefined, English is used as default one
	     */
	    language: _propTypes2.default.string
	};
	
	DisqusThread.defaultProps = {
	    url: typeof window === 'undefined' ? null : window.location.href
	};
	
	exports.default = DisqusThread;

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(442);

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDisqusComments = __webpack_require__(443);
	
	var _reactDisqusComments2 = _interopRequireDefault(_reactDisqusComments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Disqus = function (_Component) {
	  _inherits(Disqus, _Component);
	
	  function Disqus(props) {
	    _classCallCheck(this, Disqus);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = { toasts: [] };
	    _this.notifyAboutComment = _this.notifyAboutComment.bind(_this);
	    _this.onSnackbarDismiss = _this.onSnackbarDismiss.bind(_this);
	    return _this;
	  }
	
	  Disqus.prototype.onSnackbarDismiss = function onSnackbarDismiss() {
	    var _state$toasts = this.state.toasts,
	        toasts = _state$toasts.slice(1);
	
	    this.setState({ toasts: toasts });
	  };
	
	  Disqus.prototype.notifyAboutComment = function notifyAboutComment() {
	    var toasts = this.state.toasts.slice();
	    toasts.push({ text: 'New comment available!!' });
	    this.setState({ toasts: toasts });
	  };
	
	  Disqus.prototype.render = function render() {
	    var _props = this.props,
	        postNode = _props.postNode,
	        shortName = _props.shortName,
	        siteUrl = _props.url;
	
	    var post = postNode.frontmatter;
	    var url = siteUrl + postNode.fields.slug;
	    return _react2.default.createElement(_reactDisqusComments2.default, {
	      shortname: shortName,
	      identifier: post.title,
	      title: post.title,
	      url: url,
	      category_id: post.category_id,
	      onNewComment: this.notifyAboutComment
	    });
	  };
	
	  return Disqus;
	}(_react.Component);
	
	exports.default = Disqus;
	module.exports = exports['default'];

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _moment = __webpack_require__(78);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Disqus = __webpack_require__(225);
	
	var _Disqus2 = _interopRequireDefault(_Disqus);
	
	__webpack_require__(436);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostTemplateDetails = function (_React$Component) {
	  _inherits(PostTemplateDetails, _React$Component);
	
	  function PostTemplateDetails() {
	    _classCallCheck(this, PostTemplateDetails);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PostTemplateDetails.prototype.render = function render() {
	    var _props$siteMetadata = this.props.siteMetadata,
	        subtitle = _props$siteMetadata.subtitle,
	        author = _props$siteMetadata.author,
	        disqusShortname = _props$siteMetadata.disqusShortname,
	        url = _props$siteMetadata.url;
	
	    var post = this.props.post;
	    var tags = post.fields.tagSlugs;
	
	    var homeBlock = _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'post-single__home-button', to: '/' },
	        'All Articles'
	      )
	    );
	
	    var tagsBlock = _react2.default.createElement(
	      'div',
	      { className: 'post-single__tags' },
	      _react2.default.createElement(
	        'ul',
	        { className: 'post-single__tags-list' },
	        tags && tags.map(function (tag, i) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'post-single__tags-list-item', key: tag },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: tag, className: 'post-single__tags-list-item-link' },
	              post.frontmatter.tags[i]
	            )
	          );
	        })
	      )
	    );
	
	    var commentsBlock = _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Disqus2.default, { postNode: post, shortName: disqusShortname, url: url })
	    );
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      homeBlock,
	      _react2.default.createElement(
	        'div',
	        { className: 'post-single' },
	        _react2.default.createElement(
	          'div',
	          { className: 'post-single__inner' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'post-single__title' },
	            post.frontmatter.title
	          ),
	          _react2.default.createElement('div', { className: 'post-single__body', dangerouslySetInnerHTML: { __html: post.html } }),
	          _react2.default.createElement(
	            'div',
	            { className: 'post-single__date' },
	            _react2.default.createElement(
	              'em',
	              null,
	              'Published ',
	              (0, _moment2.default)(post.frontmatter.date).format('D MMM YYYY')
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'post-single__footer' },
	          tagsBlock,
	          _react2.default.createElement('hr', null),
	          _react2.default.createElement(
	            'p',
	            { className: 'post-single__footer-text' },
	            subtitle,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://twitter.com/' + author.twitter, target: '_blank', rel: 'noopener noreferrer' },
	              _react2.default.createElement('br', null),
	              ' ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                author.name
	              ),
	              ' on Twitter'
	            )
	          ),
	          disqusShortname && commentsBlock
	        )
	      )
	    );
	  };
	
	  return PostTemplateDetails;
	}(_react2.default.Component);
	
	exports.default = PostTemplateDetails;
	module.exports = exports['default'];

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PostTemplateDetails = __webpack_require__(229);
	
	var _PostTemplateDetails2 = _interopRequireDefault(_PostTemplateDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostTemplate = function (_React$Component) {
	  _inherits(PostTemplate, _React$Component);
	
	  function PostTemplate() {
	    _classCallCheck(this, PostTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PostTemplate.prototype.render = function render() {
	    var siteMetadata = this.props.data.site.siteMetadata;
	    var title = siteMetadata.title,
	        subtitle = siteMetadata.subtitle;
	
	    var post = this.props.data.markdownRemark;
	    var _post$frontmatter = post.frontmatter,
	        postTitle = _post$frontmatter.title,
	        postDescription = _post$frontmatter.description;
	
	    var description = postDescription !== null ? postDescription : subtitle;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          postTitle + ' - ' + title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: description })
	      ),
	      _react2.default.createElement(_PostTemplateDetails2.default, { siteMetadata: siteMetadata, post: post })
	    );
	  };
	
	  return PostTemplate;
	}(_react2.default.Component);
	
	exports.default = PostTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-post-template-jsx-d7589e304c7c1cd853c9.js